module.exports = __webpack_public_path__ + "img/EMT-CRC_GSE206552.d897af44.png";